import { ComponentType } from 'react';

type MenuClickGTMType = {
  onMenuItemClick?: ({
    label,
    isOpen,
    parents,
  }: {
    label: string;
    isOpen: boolean;
    parents?: string[];
  }) => void;
};

export const withGtmMenuClick =
  <T extends MenuClickGTMType>(
    Component: ComponentType<
      React.PropsWithChildren<
        React.PropsWithChildren<
          React.PropsWithChildren<React.PropsWithChildren<T>>
        >
      >
    >,
    action: string
  ) =>
  (props: T) => {
    const onMenuItemClick: MenuClickGTMType['onMenuItemClick'] = ({
      label,
      isOpen,
      parents,
    }) => {
      isOpen &&
        addMenuClickEventsToGTM(
          !parents ? label : parents.join(' - ') + ' - ' + label,
          action
        );
    };

    return <Component {...props} onMenuItemClick={onMenuItemClick} />;
  };

export const addMenuClickEventsToGTM = (
  label: string,
  action = 'Menu Click'
) => {
  dataLayer.push({
    Category: 'Menu Click',
    Action: action,
    Label: label,
    noninteraction: false,
    event: 'gaEvent',
  });
};
